import { announcementsConstants } from '../constants/announcementsConstants';
import { announcementsService } from '../../services/API/announcementsService';
import { history }              from '../store/configureStore';

export const getActiveAnnouncements = (postData) => {
  return dispatch => {
    announcementsService.getActiveAnnouncements(postData)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: announcementsConstants.GET_ANNOUNCEMENTS_REQUEST, data } }
  function success(data) { return { type: announcementsConstants.GET_ANNOUNCEMENTS_SUCCESS, data } }
  function failure(error) { return { type: announcementsConstants.GET_ANNOUNCEMENTS_FAILURE, error } }
}


// WEBPACK FOOTER //
// ./src/app/redux/actions/announcementsActions.js